import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialTypography from "../../../components/MaterialTypography";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Stack,
  Button,
  TextField,
  Box,
} from "@mui/material";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import moment from "moment-timezone";
import { gql } from "@apollo/client";
import Swal from "sweetalert2";
import { cancelApiIntergration } from "../../../functions/cancelApi/cancelApi";
import { useLoading } from "../../../context/loading";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
const cancelwfhrequest = gql`
  mutation cancelwfhrequest($id: Int!) {
    CancelWFHRequest(id: $id) {
      success

      message

      error
    }
  }
`;
function WFHViewScreen() {
  const [employeeData, setemployeeData] = useState([]);
  const navigate = useNavigate();
  const [id, setId] = useState(null);
  const { circleLoading, setCirleLoading } = useLoading();
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    }
  }, []);

  const getInitData = async (id) => {
    const query = ` query WfhRequestGetById($id: String!){ 

  getWfhById(id: $id){ 

    data{ 

      id 

      user{ 

        id 

        firstName 

        lastName 

        email 

        empid 

      } 

      leaveType{ 

        id 

        name 

      } 

      requestedDate 

      startDate 

      endDate 

      reason 

      totalDays 

      task 

      teamleaderId 

      teamApproval 

      hrApproval 

      status 

      approvalStatus{ 

        id 

        status 

        approver{ 

          id 

          firstName 

          lastName 

          email 

        } 

      } 

    } 

    success 

    error 

    message 

  } 

}  `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // const regularizationRowdata = response.data.data.getRegularizationById?.data[0];
      const weekoffRowdata = response.data.data.getWfhById?.data[0];
      setemployeeData(weekoffRowdata);
      // if (
      //   (Roledata == "Hr" || Roledata == "HR") &&
      //   weekoffRowdata.teamApproval === "approved" &&
      //   weekoffRowdata.hrApproval === "pending"
      // ) {
      //   setdisplay(true);
      // }
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };
  const checkInTime = moment(employeeData.checkIn)
    .tz("Your/Timezone", true)
    .format("M/D/YYYY, h:mm:ss a");
  const checkOutTime = moment(employeeData.checkOut)
    .tz("Your/Timezone", true)
    .format("M/D/YYYY, h:mm:ss a");

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // This will return 'dd/mm/yyyy' format
  }

  const handleclose = () => {
    navigate("/wfh-management");
  };

  const handleCancelLeave = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to cancel your WFH.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setCirleLoading(true);
        const { status } = await cancelApiIntergration(cancelwfhrequest, id);
        setCirleLoading(false);

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Cancel successfully",
          showConfirmButton: false,
          timer: 4500,
        }).then(() => {
          navigate("/wfh-management");
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ padding: 1, boxShadow: 4, borderRadius: 2 }}>
        {/* Card Title */}
        <CardHeader
          title={
            <Typography
              variant="h5"
              fontWeight="bold"
              textAlign="center"
              gutterBottom
            >
              WFH Details
            </Typography>
          }
        />

        {/* Leave Details Content */}
        <CardContent>
          <Grid container spacing={1} marginLeft={"4%"}>
            {/* Left Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>User Name:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.user?.firstName?.toUpperCase() + " " + employeeData?.user?.lastName?.toUpperCase()}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Start Date:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.startDate}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>End Date:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.endDate}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Total Days:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.totalDays}
                  </span>
                </Typography>
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>Reason:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.reason}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Manager Approval:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.teamApproval == "approved"
                      ? "Approved"
                      : employeeData?.teamApproval == "rejected"
                      ? "Rejected"
                      : employeeData?.teamApproval}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>HR Approval:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.hrApproval == "approved"
                      ? "Approved"
                      : employeeData?.hrApproval == "rejected"
                      ? "Rejected"
                      : employeeData?.hrApproval}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.status == "approved"
                      ? "Approved"
                      : employeeData?.status == "rejected"
                      ? "Rejected"
                      : employeeData?.status}
                  </span>
                </Typography>
              </Stack>
            </Grid>
          </Grid>

          {/* Buttons */}
          <Grid container spacing={2} justifyContent="center" marginTop={4}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <MaterialButton
                variant="contained"
                color="dark"
                onClick={() => handleclose()}
              >
                Close
              </MaterialButton>
              {employeeData?.status?.toLowerCase() !== "cancelled" &&
                employeeData?.status?.toLowerCase() !== "rejected" && (
                  <MaterialButton
                    variant="contained"
                    color="error"
                    onClick={() => handleCancelLeave()}
                    sx={{ marginLeft: "10px" }}
                  >
                    Cancel WFH
                  </MaterialButton>
                 
                )}
            </Box>
          </Grid>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default WFHViewScreen;